import React from "react";
import { Button } from "react-bootstrap";
import {
  IIconButton, IconButtonType, IconButtonTypeClass, IconButtonTypeComponent
} from "../../interfaces/Components/IconButton/IIconButton";
import { Spinner } from "../Spinner/Spinner";

import "./IconButton.scss";

export const IconButton: React.FC<IIconButton> = ({
  iconType, spin, children, ...props
}) => {
  const buttonClassName = `icon-button ${IconButtonTypeClass[iconType]} ${props.className || ""}`;

  const renderPreStatus = () => {
    if (spin && iconType !== IconButtonType.Next) return <Spinner animation="grow" visible spinnerText="Sending" />;
    if (iconType === IconButtonType.Next) {
      return null;
    }
    return IconButtonTypeComponent[iconType];
  };

  const renderPostStatus = () => {
    if (iconType !== IconButtonType.Next) return null;
    return spin
      ? <Spinner animation="grow" visible spinnerText="Sending" />
      : IconButtonTypeComponent[IconButtonType.Next];
  };

  return (
    <Button {...props} className={buttonClassName}>
      <div className="wrapper">
        {renderPreStatus()}
        <div className="children">
          {children}
        </div>
        {renderPostStatus()}
      </div>
    </Button>
  );
};
